import * as React from 'react';
import ArticleTabVariantList from '../article-tab-variant-list/article-tab-variant-list';
import FootnoteService from 'PyzShopUi/scripts/shop-ui/services/FootnoteService';
import {EFootnoteNamespace} from 'PyzShopUi/scripts/shop-ui/constants';
import Footnote from 'PyzShopUi/scripts/footnote/components/Footnote';
import EventBus from 'PyzShopUi/scripts/utils/eventBus';
import {EProductDetailPageEvents} from 'PyzShopUi/scripts/product-detail-page/events/pdpEvent';
import {useTranslationHook} from 'PyzShopUi/scripts/utils/translationHook';
import {useEnhancedReducer} from 'PyzShopUi/scripts/shop-ui/includes/enhanced-reducer';
import {productVariantsReducer} from '../article-tab-variant-list/reducer';
import {ProductVariantActionState, ApiQueryData} from '../article-tab-variant-list/interfaces';
import useApiQueryDataUpdate from '../article-tab-variant-list/hooks/use-api-query-data-update';
import {getProductVariant, initProductVariantState} from '../article-tab-variant-list/actions/get-variant';
import LoadMore from '../article-tab-variant-list/load-more';
import Loading from 'PyzShopUi/scripts/react/common/components/Loading';
import {PARAM_PAGE} from '../article-tab-variant-list/constants';

const newApiQueryData: ApiQueryData = {
    [PARAM_PAGE] : '1'
};
const emptyProductVariantListState: ProductVariantActionState = {
    productVariants: [],
    isPageLoading: true,
    apiQueryData: newApiQueryData,
    currentPage: 1,
    maxPage: 1,
};

const articleTabVariants = props => {
    const { data, addToCartApiUrl, recommendationApiUrl, dataEtrackerProductCurrency } = props;
    const variants = data.variants;
    const lastUpdated = data.last_updated;
    const currentCalendarWeek = data.current_calendar_week;
    const showColor = data.show_color;
    const showSize = data.show_size;
    const isBikeSpecificArticle = data.is_bike_specific;
    const csrfToken = data.csrf_token;
    const footnoteService = React.useRef<FootnoteService>(FootnoteService.getInstance());
    const isSprykerSapCcosApiActiveElement = document.querySelector('[data-is-sap-ccos-api-active]');
    const isSprykerSapCcosApiActive = !!isSprykerSapCcosApiActiveElement.getAttribute('data-is-sap-ccos-api-active');
    let productAllVariants = variants;

    const [state, dispatch] = useEnhancedReducer(productVariantsReducer, emptyProductVariantListState);
    const {
        productVariants,
        isPageLoading,
        apiQueryData,
        currentPage,
        maxPage,
    } = state;

    if (isSprykerSapCcosApiActive) {
        useApiQueryDataUpdate(apiQueryData, dispatch);
        React.useEffect(() => {
            dispatch(getProductVariant(data));
        }, []);
        productAllVariants = productVariants;
    }
    const displayLoadMore = () => {
        if (currentPage < maxPage) {
            return (
                <LoadMore
                    currentPage={currentPage}
                    maxPage={maxPage}
                    dispatch={dispatch}
                    isProgressing={isPageLoading}
                />
            );
        }

        return undefined;
    };
    const displayLoading = () => {
        return <Loading/>;
    };

    const { translate } = useTranslationHook();
    const dataGiftCardproductType = document.querySelector('[data-gift-card-product-type]');
    const giftCardProductType = dataGiftCardproductType ? dataGiftCardproductType.getAttribute('data-gift-card-product-type') : undefined;

    return (
        <div className="cell">
            <span className="bold"
                  style={{visibility: giftCardProductType === 'KF' ? 'visible' : 'hidden'}}>
                {translate('No Variant found', {ns: 'article-detail'})}
            </span>
            <div className="article-all-variants" data-qa="article-all-variants"
                 style={{visibility: giftCardProductType === 'KF' ? 'hidden' : 'visible'}}>
                <div className="grid-x grid-padding-x">
                    <div className="cell small-12 medium-4 large-3">
                        <span className="bold">{translate('Current calendar week', { ns: 'article-detail' })}: </span>
                        <time>{currentCalendarWeek}</time>
                    </div>
                    <div className="cell small-12 medium-8 large-9">
                        <span className="bold">{translate('Last updated', { ns: 'article-detail' })}: </span>
                        <time>{lastUpdated}</time>
                    </div>
                </div>

                <div className="grid-x grid-padding-x">
                    <div className="cell">
                        <table className="stack text-left">
                            <thead>
                                <tr>
                                    <th>{translate('Product', 'article-detail')}</th>
                                    <th>{translate('Art. No.', { ns: 'article-detail' })}</th>
                                    <th>{translate('Availability', { ns: 'article-detail' })}</th>
                                    <th>{translate('Price', { ns: 'article-detail' })}</th>
                                    <th className="row-actions">{translate('Actions', { ns: 'article-detail' })}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <ArticleTabVariantList
                                    isBikeSpecificArticle={isBikeSpecificArticle}
                                    csrfToken={csrfToken}
                                    addToCartApiUrl={addToCartApiUrl}
                                    recommendationApiUrl={recommendationApiUrl}
                                    productVariants={productAllVariants}
                                    dataEtrackerProductCurrency={dataEtrackerProductCurrency}
                                />
                            </tbody>
                        </table>
                        {isSprykerSapCcosApiActive && displayLoading() }
                        {isSprykerSapCcosApiActive && displayLoadMore() }
                        <Footnote
                            footnotes={footnoteService.current.getNamespace(EFootnoteNamespace.PDP_ALL_VARIANTS_ARTICLE_PRICE).getFootnotes()}
                            extraInformation={footnoteService.current.getExtraInformation()}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default articleTabVariants;
